import { AppManifest, parse as parseManifest } from './app-manifest';

interface AppManifestV2 extends AppManifest {
  /** Forma explícita de declarar a versão do manifest V2 */
  manifestVersion?: 'V2';
}

const parse = (json: AppManifestV2): AppManifestV2 => {
  return parseManifest(json);
};

export { AppManifestV2, parse };
